// Classes
import { DemographicsReducerState } from "Containers/Filter/Demographics/classes/demographics.classes";
import { AttributeObject } from "../classes/attributes.classes";

/**
 * @function getEthnicityAttributes
 *
 * Post-processes the attributes for this section of the filter
 *
 * @param {DemographicsReducerState} demographics - The current state
 * of the Demographics filter section.
 * @return {AttributeObject | undefined}
 *
 * @example
 *
 *     getEthnicityAttributes(demographics)
 */
export const getEthnicityAttributes = (
  demographics: DemographicsReducerState
) => {
  const attributeArray = [
    (demographics.ethnicity.americanIndianOrAlaskaNative &&
      "American Indian or Alaska Natice") ||
      undefined,
    (demographics.ethnicity.asian && "Asian") || undefined,
    (demographics.ethnicity.blackOrAfricanAmerican &&
      "Black or African American") ||
      undefined,
    (demographics.ethnicity.hispanicOrLatin && "Hispanic or Latin") ||
      undefined,
    (demographics.ethnicity.mixedRace && "Mixed Race") || undefined,
    (demographics.ethnicity.nativeHawaiianOrOtherPacificIslander &&
      "Native Hawaiian or Other Pacific Islander") ||
      undefined,
    (demographics.ethnicity.other && "Other") || undefined,
    (demographics.ethnicity.white && "White") || undefined
  ].filter(attributeObject => typeof attributeObject !== "undefined");

  let attributeObject: any;

  if (attributeArray.length > 0) {
    attributeObject = new AttributeObject(
      (attributeArray.length > 1 && `Ethnicity=${attributeArray.length}`) ||
        attributeArray[0],
      "standard",
      attributeArray.length > 1 && attributeArray
    );
  } else {
    attributeObject = undefined;
  }

  return attributeObject;
};
try {
    // @ts-ignore
    getEthnicityAttributes.displayName = "getEthnicityAttributes";
    // @ts-ignore
    getEthnicityAttributes.__docgenInfo = { "description": "", "displayName": "getEthnicityAttributes", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Attributes/utilities/getEthnicityAttributes.ts#getEthnicityAttributes"] = { docgenInfo: getEthnicityAttributes.__docgenInfo, name: "getEthnicityAttributes", path: "src/shared/containers/Attributes/utilities/getEthnicityAttributes.ts#getEthnicityAttributes" };
}
catch (__react_docgen_typescript_loader_error) { }